import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateLiftComponent } from './create-lift/create-lift.component';
import { SearchLiftComponent } from './search-lift/search-lift.component';
import { ViewLiftComponent } from './view-lift/view-lift.component';
import { LiftRoutingModule } from './lift-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatCardModule } from '@angular/material';

@NgModule({
  declarations: [CreateLiftComponent, SearchLiftComponent, ViewLiftComponent],
  imports: [CommonModule, LiftRoutingModule, SharedModule, MatCardModule],
})
export class LiftModule {}
